import { render } from "./dropZoneTexto.vue?vue&type=template&id=41b540ee&scoped=true"
import script from "./dropZoneTexto.vue?vue&type=script&lang=js"
export * from "./dropZoneTexto.vue?vue&type=script&lang=js"

import "./dropZoneTexto.vue?vue&type=style&index=0&id=41b540ee&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b540ee"]])

export default __exports__